import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { handleLogin } from "../../common/routines/user-operations";
import { getCartCount } from "../../api/cart.api";
import store from "../../store";
import { initSessionTimers } from "../../common/session/sessionTimer";

const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get("token");
    const user = searchParams.get("user");
    const stateParam = searchParams.get("state");
    let stateRedirect = null;

    if (stateParam) {
      try {
        const parsedState = JSON.parse(decodeURIComponent(stateParam));
        stateRedirect = parsedState.redirect;
      } catch (err) {
        console.error("Failed to parse OAuth state:", err);
      }
    }

    if (token) {
      let parsedUser: any = {};

      if (user) {
        try {
          parsedUser = JSON.parse(decodeURIComponent(user));
        } catch (err) {
          console.error("Invalid user JSON from callback:", user, err);
          parsedUser = {};
        }
      }

      const normalizedUser = {
        ...parsedUser,
        profile_photo: parsedUser?.avatarUrl || parsedUser?.profile_photo || "",
      };

      const userData = {
        accessToken: token,
        refreshToken: token, // Fallback if not provided
        user: normalizedUser,
      };

      handleLogin(userData);

      // Fetch cart count immediately after social login
      const fetchCart = async () => {
        try {
          const res = await getCartCount();
          const count = res.data?.data?.data?.count ?? 0;
          store.dispatch({ type: "CART:SET_COUNT", payload: { count } });
        } catch (error) {
          console.error("Failed to fetch cart count after social login:", error);
        }
      };

      fetchCart();

      const postLoginRedirect = localStorage.getItem("postLoginRedirect");
      const redirect = searchParams.get("redirect") || stateRedirect || postLoginRedirect || "/home";
      navigate(redirect);
      if (postLoginRedirect) {
        localStorage.removeItem("postLoginRedirect");
      }
    } else {
      navigate("/"); // fallback to login page
    }
  }, []);

  // eslint-disable-next-line react/react-in-jsx-scope
  return <p>Signing you in...</p>;
};

export default AuthCallback;
